import { SelectDatePaginatorStyle } from './SelectDatePaginatorStyle'
import { SelectMonthSimple } from './SelectMonthSimple'
import { SelectYearSimple } from './SelectYearSimple'

export const SelectMoment = {
  SelectDatePaginatorStyle,
  SelectMonthSimple,
  SelectYearSimple,
}
